import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { Lecture } from 'src/app/models/lecture';
import { HelpersService } from 'src/app/services/helpers.service';
declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  waitDownload = false;
  searchResults!: Lecture[];
  public request: any = {};
  public showTutor = false;
  public showLessons = false;
  public showPresences = false;

  constructor(private router: Router,
              private dataService: DataService,
              public helperService: HelpersService) { }

  ngOnInit(): void {
    this.showTutor = this.helperService.checkRole('ROLE_BACKOFFICE_TUTOR');
    this.showLessons = this.helperService.checkRole('ROLE_BACKOFFICE_LESSON');
    this.showPresences = this.helperService.checkRole('ROLE_SUPERVISOR');
  }

  openMenu(): void{
    $('#modalMenu').modal('show');
  }

  goTo(route: string): void{
    $('#modalMenu').modal('hide');
    if (route === 'logout') {
      this.helperService.logout();
    } else {
      this.router.navigateByUrl(route);
    }
  }

}
